import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import clsx from 'clsx';
    import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CButton',
  props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: "",
        }
    },
  setup(__props) {

const props = __props

    

    const buttonDisabled = computed(() => {
        return props.disabled
    })

    const classes = computed(() => {
        return clsx(
            props.className,
            props.outline ? "border border-capPurple bg-white text-capPurple" : "bg-capPurple text-white",
            "rounded-md m-auto text-md font-semibold px-4 py-2 flex"
        )
    })

return (_ctx: any,_cache: any) => {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    disabled: _unref(buttonDisabled) || __props.loading ? true : false,
    class: _normalizeClass(_unref(classes))
  }, [
    (!__props.loading)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createBlock(_component_loading, { key: 1 }))
  ], 10, _hoisted_1))
}
}

})